import * as React from 'react'
import { Column, ColumnValue } from './types'

interface HiddenInputsProps {
  columns: Column[]
  values: Record<number, ColumnValue>
  namePrefix: string
}

export default function HiddenInputs({ columns, values, namePrefix }: HiddenInputsProps) {
  return (
    <div style={{ display: 'none' }}>
      {columns.map((column, index) => {
        const value = values[column.id]
        const prefix = `${namePrefix}[${index}]`

        // Handle array values for multiselect columns
        const rawValue = value?.value
        const serializedValue = Array.isArray(rawValue)
          ? JSON.stringify(rawValue)
          : (rawValue ?? '')

        return (
          <span key={column.id}>
            {value?.id && (
              <input type="hidden" name={`${prefix}[id]`} value={value.id} />
            )}
            <input
              type="hidden"
              name={`${prefix}[projects_column_id]`}
              value={column.id}
            />
            <input
              type="hidden"
              name={`${prefix}[value]`}
              value={serializedValue}
            />
          </span>
        )
      })}
    </div>
  )
}
